<template lang="pug">
v-dialog(v-model='dialog', :max-width='options.width', @keydown.esc='cancel', content-class='confirm-dialog')
  v-toolbar(dark, :color='options.color', dense)
    v-toolbar-title.white--text {{ title }}
  v-card(tile)
    v-card-text(v-show='!!message') {{ message }}
    v-card-actions.pa-4
      v-btn(@click.native='cancel', v-if='options.cancelButton') Annuleren
      v-spacer
      v-btn(:color='options.color', dark, @click.native='agree') {{ options.confirmLabel }}
</template>

<script>
/**
 * Vuetify Confirm Dialog component
 *
 * Insert component where you want to use it:
 * <confirm ref="confirm"></confirm>
 *
 * Call it:
 * this.$refs.confirm.open('Delete', 'Are you sure?', { color: 'red' }).then((confirm) => {});
 *
 * Alternatively you can place it in main App component and access it globally via this.$root.$confirm
 * <template>
 *   <v-app>
 *     ...
 *     <confirm ref="confirm"></confirm>
 *   </v-app>
 * </template>
 *
 * mounted() {
 *   this.$root.$confirm = this.$refs.confirm.open;
 * }
 */
export default {
  data () {
    return {
      dialog: false,
      resolve: null,
      reject: null,
      message: null,
      title: null,
      options: {
        color: 'primary',
        width: 450,
        confirmLabel: 'OK',
        cancelButton: true
      }
    }
  },

  methods: {
    open (title, message, options) {
      this.dialog = true
      this.title = title
      this.message = message
      this.options = Object.assign(this.options, options)

      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },

    agree () {
      this.resolve(true)
      this.dialog = false
    },

    cancel () {
      this.reject('dialog closed')
      this.dialog = false
    }
  }
}
</script>

<style lang="scss">
.confirm-dialog {
  .v-card__text {
    white-space: pre-wrap;
  }
}
</style>
